import store from 'store/index';
import { claimTypes, currentClaimType, currentClaimStepIndex } from 'store/modules/claim';

/**
 * Get a specific step by it's index from the current claim type.
 * 
 * @param  {int} index 
 */
export const getStepByNumber = (index) => {
    const steps = store.getters[currentClaimType() + '/step/allSteps'];
    const id = store.getters['claim/id'];

    if (steps[index]) {
        steps[index]['route']['params']['id'] = id;
        return steps[index];
    }
};

/**
 * Return the next step if one exists, or null.
 * 
 * @return {Object|null} 
 */
export const nextStep = () => {
    return getStepByNumber(currentClaimStepIndex() + 1);
}

/**
 * Return the previous step if one exists, or null.
 * 
 * @return {Object|null} 
 */
export const prevStep = () => {
    return getStepByNumber(currentClaimStepIndex() - 1);
}

/**
 * Does the state flag for this step say valid?
 *
 * @param stepNo
 */
export const isStepValid = (stepNo) => {
    if (!currentClaimType()) {
        return;
    }

    return store.getters[currentClaimType() + '/step/valid'](stepNo - 1);
};

/**
 * Set the state flag for the current step to valid.
 * 
 * @param  {Boolean} isValid 
 */
export const setStepValid = (isValid) => {
    if (!currentClaimType()) {
        return;
    }

    const index = store.getters[currentClaimType() + '/step/currentStepIndex'];

    return store.dispatch(
        currentClaimType() + '/step/setValid',
        { 
            valid: isValid, 
            index
        }
    );
};

/**
 * Is a user allowed to go from one step to another?
 *
 * Going down steps is always allowed, other wise it must be valid. If we are attempting to leap forwards further than
 * the next step, the step we are attempting to jump to much be valid.
 *
 * @param fromStep
 * @param toStep
 */
export const isStepTransitionAllowed = (fromStep, toStep) => {
    if (toStep < fromStep) {
        return true;
    }

    if (toStep === 9) {
        return isStepValid(8);
    }

    if (fromStep + 1 !== toStep) {
        return (isStepValid(fromStep) && isStepValid(toStep - 1));
    }

    return isStepValid(fromStep);
};

/**
 * Save a step.
 *
 * @param step
 */
export const saveStep = (stepNo) => {
    return store.dispatch('claim/save', stepNo - 1);
};

/**
 * Does the route contain the meta data to page it a "step"
 * @param route
 * @return {boolean}
 */
export const isStepRoute = (route) => {
    return !!(route.meta && route.meta.step);
};

/**
 * Alert save error
 * @param error
 */
export const stepError = (error) => {
    console.log(error); // TODO: Alert user to error
};

/**
 * Called before all route changes,
 *
 * Saved the claim and validates if it's ok to move on
 *
 * @param to
 * @param from
 * @param next
 * @return {*}
 */
export const beforeEnter = (to, from, next) => {
    // Is the user logged in
    if(store.getters['user/getToken'] === null) {
        next({name: 'homepage'});
    }

    // Update below to use correct indexOf routing dynamically
    if(!~from.path.indexOf(currentClaimType) && to.meta.step === 1) {
        return next();
    }

    // Invalid route
    if (isStepRoute(from) && isStepRoute(to) && !isStepTransitionAllowed(from.meta.step, to.meta.step)) {
        return;
    }

    // If coming from a non-step route and not going to first step
    if (!isStepRoute(from) && isStepRoute(to) && to.meta.step !== 1) {
        next({name: 'homepage'});
    }

    // We allow it, so save the step
    if (isStepRoute(from) && isStepValid(from.meta.step)) {
        return saveStep(from.meta.step)
            .then(() => next(), stepError);
    }

    // Carry on, nothing to see here
    return next();
};


// WEBPACK FOOTER //
// ./src/services/routingMethods.js